import { createFileRoute } from '@tanstack/react-router';
import { InAppSettingsRouteView } from '@/pages/workspaces/settings/actions/in_app/in-app-settings-route-view';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/in_app')({
  component: InAppSettingsRouteView,
});
